export const getUsersListWithoutDuplicates = (assignedUsers: string[]) => {
  const usersWithoutDuplicates = [...new Set(assignedUsers)];

  return usersWithoutDuplicates.map((user) => ({
    userIdentifier: user,
  }));
};
